import React, { useEffect, useState } from 'react';
import { useLocation } from 'wouter';

import CloseSvg from '@/components/common/CloseSvg';
import { useAuthenticated } from '@/components/shopping_bag/hooks/useAuthenticated';

import { AccordionButton } from '../Components/Accordion';
import { CardTypeSelector } from '../Components/CardTypeSelector';
import { EditAddress } from '../Components/EditAddress';
import { FormAddress } from '../Components/FormAddress';
import { FormGiftCard } from '../Components/FormGiftCard';
import { ManageBilling } from '../Components/ManageBilling';
import { ManageShipping } from '../Components/ManageShipping';
import { useAddress } from '../Context/AddressContext';
import { useAccount } from '../hooks/useAccount';
export const Address = () => {
    const {
        accordionStates,
        setAccordionStates,
        setMode,
        setMode2,
        showNotification,
        setShowNotification,
        showWarning,
        setShowWarning,
    } = useAddress();
    const isAuthenticated = useAuthenticated();
    const { data, isFetching, error } = useAccount(isAuthenticated);
    const [addressErrorMessage, setAddressErrorMessage] = useState('');
    const [location] = useLocation();
    useEffect(() => {
        // Reset the state when the route changes
        setAccordionStates([
            { id: 0, isOpen: true },
            { id: 1, isOpen: true },
            { id: 2, isOpen: false },
        ]);
        setMode('view');
        setMode2('view');
    }, [location]);

    return (
        <>
            <div className="address payment px-5 md:px-0">
                <h1 className="m-0 text-base font-bold text-[#1a1a1a] md:text-2xl md:leading-8">Manage addresses</h1>

                <div className="payment__manage my-5 bg-[#f8f8f8] px-5 py-3">
                    <AccordionButton
                        title="Manage shipping addresses"
                        ariaControls="paymentAccordion1"
                        id={0}
                        setMode={setMode}
                        setMode2={setMode2}
                        addressMode={true}
                        stateFromParent={accordionStates[0].isOpen}
                        accordionStates={accordionStates}
                        setAccordionStates={setAccordionStates}
                    >
                        <ManageShipping />
                    </AccordionButton>
                </div>
                {data?.BillingAddress && (
                    <div className="payment__manage my-5 bg-[#f8f8f8] px-5 py-3">
                        <AccordionButton
                            title="Manage billing address"
                            ariaControls="paymentAccordion1"
                            id={1}
                            setMode={setMode}
                            setMode2={setMode2}
                            addressMode={true}
                            stateFromParent={accordionStates[1].isOpen}
                            accordionStates={accordionStates}
                            setAccordionStates={setAccordionStates}
                        >
                            <ManageBilling />
                        </AccordionButton>
                    </div>
                )}
                <div className="payment__add my-5 bg-[#f8f8f8] px-5 py-3">
                    <AccordionButton
                        title="Add a new address"
                        ariaControls="paymentAccordion2"
                        id={2}
                        addressMode={true}
                        setMode={setMode}
                        setMode2={setMode2}
                        stateFromParent={accordionStates[2].isOpen}
                        accordionStates={accordionStates}
                        setAccordionStates={setAccordionStates}
                    >
                        <EditAddress />
                        {/* <FormAddress setFormError={setAddressErrorMessage} /> */}
                    </AccordionButton>
                </div>
            </div>
        </>
    );
};
